export const LOAD_OFFER_PARTNER_KNOCKOUT_CRITERIA_SUCCESS = "LOAD_OFFER_PARTNER_KNOCKOUT_CRITERIA_SUCCESS";
